/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombinSplitFromVo
 */
export interface CombinSplitFromVo {
    /**
     * 订单镜像id
     * @type {number}
     * @memberof CombinSplitFromVo
     */
    orderSnapshotId?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof CombinSplitFromVo
     */
    orderCode?: string;
}

/**
 * Check if a given object implements the CombinSplitFromVo interface.
 */
export function instanceOfCombinSplitFromVo(value: object): value is CombinSplitFromVo {
    return true;
}

export function CombinSplitFromVoFromJSON(json: any): CombinSplitFromVo {
    return CombinSplitFromVoFromJSONTyped(json, false);
}

export function CombinSplitFromVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombinSplitFromVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderSnapshotId': json['orderSnapshotId'] == null ? undefined : json['orderSnapshotId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
    };
}

export function CombinSplitFromVoToJSON(json: any): CombinSplitFromVo {
    return CombinSplitFromVoToJSONTyped(json, false);
}

export function CombinSplitFromVoToJSONTyped(value?: CombinSplitFromVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderSnapshotId': value['orderSnapshotId'],
        'orderCode': value['orderCode'],
    };
}

